
export default{
  // @Driver
  newIntegrationLink: {},
  newIntegrationLinks: [],
  newPromoSignupLink: {},
}